import { Middleware } from '@/modules/shared/routes/types'
import { useAuthStore } from '../stores/auth-store'

export const requireAuthentication: Middleware = (to, _from, next) => {
  const authStore = useAuthStore()

  if (to.name !== 'login' && !authStore.is_authenticated) {
    next({ name: 'login' })
    return
  }

  next()
}

export const resetAuthStore: Middleware = (_to, _from, next) => {
  useAuthStore().reset()
  next()
}
